export const INITIAL_MAP_ZOOM = 10;
export const MAX_MAP_ZOOM = 18;
export const MIN_MAP_ZOOM = 6;
